import {useCallback, useEffect, useMemo, useState} from "react";
import {Group, OptionAttribute} from "../../data";
import {useRecoilValue} from "recoil";
import {stateSelectedAccessories, stateSelectedComplectations} from "../../data/atoms";

export const useActiveGroup = (groups: Group[] | null, uid: string) => {
    const defaultGroupId = groups ? groups[0].id : null;

    const selectedComplectations = useRecoilValue(stateSelectedComplectations);
    const selectedAccessories = useRecoilValue(stateSelectedAccessories);

    const [activeGroupId, setActiveGroupId] = useState(defaultGroupId);

    const activeGroup = useMemo(
        () => (groups || []).find(group => group.id === activeGroupId) || null,
        [activeGroupId, groups]
    );

    const onActiveGroupChange = useCallback((groupId: string) => {
        setActiveGroupId(groupId);
    }, []);

    useEffect(() => {
        setActiveGroupId(defaultGroupId);
    }, [defaultGroupId]);

    /**
     * This effect is used for changing tabs
     * on randomizer change
     */
    useEffect(() => {
        const selected = {...selectedComplectations, ...selectedAccessories};

        if (selected.hasOwnProperty(uid)) {
            const groupId = selected[uid]?.group || defaultGroupId;

            setActiveGroupId(groupId);
        }
    }, [defaultGroupId, selectedAccessories, selectedComplectations, uid])


    return {
        activeGroup,
        onActiveGroupChange,
    }
};

export const useActiveOptions = (options: OptionAttribute[], groupId: string | null = null) => {
    const activeOptions = useMemo(
        () => options.filter((option) => option.group === groupId),
        [groupId, options]
    );

    return {
        activeOptions,
    }
}
